module.exports = __webpack_public_path__ + "static/media/time-eth.3f4df2e0.svg";